import { trigger, transition, query, useAnimation } from '@angular/animations';
import { fadeIn } from 'ng-animate';

const LENGTH = 1;

export const routerTransition = trigger('routerTransition', [
  transition(
    '* => void',
    query(
      ':enter, :leave',
      useAnimation(fadeIn, {
        params: { timing: LENGTH, delay: 0 },
      })
    )
  ),
]);
